//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// page
import MyOrder from "./components/MyOrder";

// component
import DeliveryModal from "../../../component/popup/DeliveryModal";
import DefaultModal from "../../../component/popup/DefaultModal";

export default function MyOrderPage({ setDeliveryModal }) {
    return <MyOrder setDeliveryModal={setDeliveryModal} />;
}
